import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const updateSiteTextsCache = (data) => {
  cache = data;
};

export const useSiteTexts = () => {
  const [texts, setTexts] = useState(cache || {});

  useEffect(() => {
    if (cache) return;
    api
      .get("/site-texts")
      .then((res) => {
        cache = res.data;
        setTexts(res.data);
      })
      .catch(() => {});
  }, []);

  return texts;
};
